// Skinline: selector de packs. Actualiza la cantidad del formulario, regalos, subtotal y envío
// según el pack elegido, y calcula la fecha de entrega con la hora de corte en hora de España.
(function () {
  const MADRID = 'Europe/Madrid';

  // Fecha y hora actuales en Madrid, independientemente de la zona horaria del cliente
  function madridNow() {
    const parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: MADRID,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .forEach((p) => (parts[p.type] = p.value));
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour };
  }

  // Antes de la hora de corte llega mañana; a partir de ella, pasado mañana
  function deliveryDate(cutoffHour, locale) {
    const now = madridNow();
    const days = now.h < cutoffHour ? 1 : 2;
    const date = new Date(Date.UTC(now.y, now.m - 1, now.d + days, 12));
    return new Intl.DateTimeFormat(locale || 'es-ES', {
      timeZone: 'UTC',
      weekday: 'long',
      month: 'short',
      day: 'numeric',
    }).format(date);
  }

  const toNumber = (text) => parseFloat(String(text || '0').replace(/\./g, '').replace(',', '.')) || 0;

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const tiers = Array.from(root.querySelectorAll('.skb__tier'));
    const gifts = Array.from(root.querySelectorAll('.skb__gift'));
    const qtyInput = root.querySelector('[data-qty-input]');
    const currency = root.dataset.currency || '€';
    const threshold = toNumber(root.dataset.freeThreshold);
    const out = (sel) => root.querySelector(sel);

    function select(tier) {
      tiers.forEach((t) => t.classList.toggle('is-selected', t === tier));
      const d = tier.dataset;
      if (qtyInput) qtyInput.value = d.qty;

      const unlocked = parseInt(d.gifts, 10) || 0;
      gifts.forEach((g, i) => g.classList.toggle('is-unlocked', i < unlocked));
      out('[data-gift-msg]').textContent = d.giftMessage;

      out('[data-compare-out]').textContent = d.compare ? currency + d.compare : '';
      out('[data-price-out]').textContent = currency + d.price;
      out('[data-saving-out]').textContent = currency + d.saving;

      const free = out('[data-free-out]');
      const isFree = threshold > 0 && toNumber(d.price) >= threshold;
      free.textContent = isFree ? free.dataset.freeUnlocked : free.dataset.freeLocked;
    }

    tiers.forEach((tier) => {
      tier.querySelector('input').addEventListener('change', () => select(tier));
    });
    select(tiers.find((t) => t.classList.contains('is-selected')) || tiers[0]);

    const dateOut = out('[data-delivery-date]');
    if (dateOut) {
      dateOut.textContent = deliveryDate(parseInt(root.dataset.cutoffHour, 10) || 14, root.dataset.dateLocale);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-skinline-bundles]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Editor de temas: volver a iniciar al recargar la sección
  document.addEventListener('shopify:section:load', initAll);
})();
